import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { IGroupWorkResource } from "../types";

export type IGroupWorkQueryParameters = {
    groupWork?: RelationalValue<IGroupWorkResource>;
};

export type IGroupWorkQueryResult = IGroupWorkResource;

export const groupWorkQuery: IApiQueryFunction<IGroupWorkQueryParameters> = ({ groupWork }) => {
    if (!groupWork) {
        return;
    }

    return {
        method: "GET",
        url: `/group_works/${mapRelationalValue(groupWork)}`,
    };
};

export const useGroupWorkQuery = createApiQueryHook<IGroupWorkQueryParameters, IGroupWorkQueryResult>(groupWorkQuery);
